module.exports = __webpack_public_path__ + "../resources/img/ic_snow_weather.035678e5.svg";